import type { IExtractApiParams } from "@routes/types";
import { generateApiPath } from "@routes/generatePath";

const pathBase = `/medical-service-provider/:doctorId/msp/:mspId/deassign`;

export type IPathBaseParams = IExtractApiParams<typeof pathBase>;

export const deassign = {
  delete: (params: IPathBaseParams) => generateApiPath(pathBase, params),
};
